export const SPARTAN_PRODUCT_EXPLORE_FEATURES_DETAIL_QUERY = 'detail';
export const SPARTAN_PRODUCT_EXPLORE_FEATURES_PAGINATION_REVEAL_OFFSET = '0%,0';
export const SPARTAN_PRODUCT_EXPLORE_FEATURES_ADAS_ID = 'adas';
export const SPARTAN_PRODUCT_EXPLORE_FEATURES_DETAIL_CHANGE_EVENT =
  'product-detail-change';
export const SPARTAN_PRODUCT_EXPLORE_FEATURES_MODAL_ID = 'features-modal';
